import React, { useState } from 'react';
import { SectionLayout } from 'components/Sections/SectionLayout';
import { Col, Row } from 'components/Core/Grid';
import WebsiteImage from 'components/WebsiteImage';
import RichText from 'components/RichText';
import FeaturedContent, { FeaturedImage, FeaturedCopy } from './FeaturedContent';
import { Container, DesktopContainer, MobileContainer } from './styles';

const InPageFeaturesV9 = (props) => {
  const { index, inPageNavigationItems, title, description, featuredItem } = props;
  const [selectedIndex, setSelectedIndex] = useState(featuredItem ? -1 : 0);

  const featuredContent = selectedIndex >= 0 ? inPageNavigationItems[selectedIndex] : featuredItem;

  const navigationItems = [[], []];

  inPageNavigationItems.forEach((item, idx) => {
    item.key = idx;
    idx % 2 === 0 ? navigationItems[0].push(item) : navigationItems[1].push(item);
  });

  const scrollToCenter = (element) => {
    const container = element.closest('.in-page-features-v9--mobile-navigation-content');
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const scrollLeft =
        container.scrollLeft +
        (elementRect.left - containerRect.left) -
        containerRect.width / 2 +
        elementRect.width / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  };

  const handleMobileItemClick = (index, event) => {
    setSelectedIndex(index);
    scrollToCenter(event.currentTarget);
  };

  return (
    <Container id="in-page-features-v9" className="in-page-features-v9 p-[0] lg:p-[80px_0]">
      {(title || description?.description) && (
        <div className="p-[0_28px] mx-auto mb-[20px] text-center  max-w-[840px] hidden lg:block">
          {title && <h2>{title}</h2>}
          {description?.description && <p>{description.description}</p>}
        </div>
      )}
      <DesktopContainer
        itemLength={inPageNavigationItems.length}
        className={`in-page-features--${index} in-page-features-v9--desktop-container min-lg`}
      >
        <SectionLayout innerContainerStyles={`min-h-[500px] !p-[20px_28px]`}>
          <Row type="flex" justify="center" gutter={80} className="h-full items-center">
            <Col
              xs={24}
              sm={12}
              className="in-page-features-v9--navigation flex flex-col justify-center items-start h-full"
              id={`in-page-features-v9--navigation--${index}`}
            >
              {(featuredItem?.title || featuredItem?.description) && (
                <div className="mb-[15px]">
                  {featuredItem.title && (
                    <h3 className="mb-[10px] text-left">{featuredItem.title}</h3>
                  )}
                  {featuredItem.description && <RichText content={featuredItem.description} />}
                </div>
              )}
              <Row type="flex" justify="start" gutter={[10, 10]} style={{ width: '100%' }}>
                {navigationItems.map((column, index1) => {
                  return (
                    <Col xs={12} key={`features-v9--nav-item-col-${index1}`}>
                      <Row type="flex" justify="start" gutter={[10, 10]} className="!p-0">
                        {column.map((item, index2) => {
                          return (
                            <Col
                              xs={24}
                              onClick={() => setSelectedIndex(item.key)}
                              key={`features-v9--nav-item-${item.key}`}
                              id={`inpagefeatures_v9_navitem_${item.contentful_id}`}
                            >
                              <div
                                className={`in-page-features-v9--item flex items-center gap-[10px] p-[10px_15px] border border-[#E5EBEE] border-solid rounded-[4px] bg-white cursor-pointer ${
                                  selectedIndex < 0 && item.key === 0 ? 'pulse-effect' : ''
                                } ${selectedIndex === item.key ? 'item-selected' : ''}`}
                              >
                                <WebsiteImage {...item.icon} />
                                <p className="font-p m-0">{item.title}</p>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col
              className="in-page-features-v9--featured-content h-full text-center"
              xs={24}
              sm={12}
            >
              <div className="h-full overflow-hidden flex flex-col items-center justify-center min-h-[500px]">
                {selectedIndex < 0 && (
                  <div className="w-full h-full flex flex-col">
                    <FeaturedContent item={{ featuredImage: featuredContent.featuredImage }} />
                  </div>
                )}
                {inPageNavigationItems.map((item, index) => (
                  <div
                    className={`w-full h-full flex flex-col ${
                      selectedIndex === index ? 'justify-center' : 'absolute left-[-999em]'
                    }`}
                    key={`featured-v9--content-container-${index}`}
                    id={`inpagefeatures_v9_content_${item.contentful_id}`}
                  >
                    <FeaturedContent item={item} />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </SectionLayout>
      </DesktopContainer>

      <MobileContainer className={`in-page-features-v9--mobile-container max-lg`}>
        <SectionLayout innerContainerStyles={`p-[20px]`}>
          {(featuredItem?.title || featuredItem?.description) && (
            <div className="mb-[15px]">
              {featuredItem.title && <h3 className="mb-[10px] text-left">{featuredItem.title}</h3>}
              {featuredItem.description && <RichText content={featuredItem.description} />}
            </div>
          )}

          <div className="in-page-features-v9--mobile-featured-image-container">
            <FeaturedImage
              image={featuredContent.featuredImage}
              video={featuredContent.featuredVideo}
            />
          </div>

          <div className="in-page-features-v9--mobile-navigation-content w-full mt-[20px] overflow-x-auto no-scrollbar">
            <div className="flex w-max">
              {inPageNavigationItems.map((item, index) => {
                return (
                  <div
                    className="pr-[10px]"
                    key={`in-page-nav-${index}`}
                    id={`mobile_inpagefeatures_navitem_${item.contentful_id}`}
                    onClick={(event) => handleMobileItemClick(index, event)}
                  >
                    <div
                      className={`in-page-features-v9--item border border-solid border-[#E5EBEE] p-[10px_15px] rounded-[4px] ${
                        selectedIndex < 0 && index === 0 ? 'pulse-effect' : ''
                      } ${selectedIndex === index ? 'bg-[var(--titan-blue-3)]' : ''}`}
                    >
                      <p
                        className={`font-p m-0 ${
                          selectedIndex === index ? 'text-white' : 'text-black'
                        }`}
                      >
                        {item.title}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="in-page-features-v9--mobile-featured-copy-container overflow-hidden">
            {inPageNavigationItems.map((item, index) => {
              return (
                <div
                  className={`in-page-features-v9--copy ${
                    selectedIndex === index ? 'justify-center' : 'absolute left-[-999em]'
                  }`}
                  key={`in-page-nav-main-${index}`}
                  id={`mobile_inpagefeatures_content_${item.contentful_id}`}
                >
                  <FeaturedCopy
                    className="mt-[20px]"
                    description={item.description}
                    link={item.link}
                  />
                </div>
              );
            })}
          </div>
        </SectionLayout>
      </MobileContainer>
    </Container>
  );
};

export default InPageFeaturesV9;
